export default {
	// 字符串转去重数组或数组去重
	distinctArray: function(val, regex) {
		regex = regex || /[,，;；:：、\n]/;
		if (val instanceof Array) {
			return val.length > 0 ? new Set(val) : undefined;
		} else {
			return val ? Array.from(new Set(val.trim().replace(/\n(\n)*( )*(\n)*\n/g, '\n').split(regex))) : undefined;
		}
	},

	//date 转 string
	transformDate(val) {
		if( !(val instanceof Date) ) {
			return val;
		}
		let year = val.getFullYear();
		let month = val.getMonth() + 1;
		let day = val.getDate();
		if (month >= 1 && month <= 9) {
			month = `0${month}`;
		}
		if (day >= 1 && day <= 9) {
			day = `0${day}`;
		}
		return `${year}年${month}月${day}日`
	},
	/**
	 * 转换日期格式 string -> 日期对象
	 * @param val 2021-09-01
	 * @return {Date} 日期对象
	 */
	strToDate(val){
		let timeStr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
		let year = timeStr[0]
		let month = timeStr[1] - 1
		let day = timeStr[2]
		return new Date(year,month,day)
	},
}



// WEBPACK FOOTER //
// ./src/util.js